import Component from 'vue-class-component';
import { ICONS } from '@/values/icons';
import { Mixins, Prop } from 'vue-property-decorator';
import NavRedirectMixin from '@/core/mixins/nav-redirect.mixin';
import { AuthPrivileges } from '@/auth/models/auth-privileges.model';
import { PRIVATE_ROUTES } from '@/app/private/private.routes';
import { EdCallsComponent } from '@/components/calls/ed-calls/ed-calls.component';


@Component({
  name: 'ed-user-menu'
})
export default class EdUserMenu extends Mixins(NavRedirectMixin) {
  @Prop({}) readonly callsComponent: EdCallsComponent;

  /* Computed */
  get userMenu() {
    return this.getMenu();
  }

  get username():string {
    if(this.$store.state.AuthStore.user.firstName) {
      return this.$store.state.AuthStore.user.firstName;
    }
    return '';
  }

  /* Methods */
  goToOption(item: any) {
    if(item.cb) {
      item.cb();
    } else {
      this.goTo(item.pathName);
    }
  }

  getMenu() {
    const $root: any = this.$root;
    const privileges: AuthPrivileges = this.$store.state.AuthStore.privileges;
    const menu: any = [{
      id: 2,
      text: this.$i18n.t('auth.userMenu.changePassword'),
      pathName: PRIVATE_ROUTES.CHANGE_PASSWORD.NAME,
      icon: ICONS.KEY_SOLID,
    },
    {
      id: 3,
      text: this.$i18n.t('auth.userMenu.logout'),
      cb: async () => {
        await this.callsComponent.handleLogout();     //Close call if any
        this.checkIfMeetingFinishAndContinue(false, () => {
          $root.logout();
        });
      }
    }];
    if(privileges.ReadPendingUserRequest) {
      menu.unshift({
        id: 1,
        text: this.$i18n.t('auth.userMenu.userRequests'),
        pathName: PRIVATE_ROUTES.USER_REQUESTS.NAME,
        icon: ICONS.USERS_SOLID
      });
    }
    return menu;
  }

}